import { useState } from 'react'
import { Loader2 } from 'lucide-react'

interface PDFPreviewProps {
  url: string
}

export function PDFPreview({ url }: PDFPreviewProps) {
  const [loading, setLoading] = useState(true)

  // Add PDF Open Parameters to control initial view
  // #page=1 - Open to first page
  // &toolbar=0 - Hide toolbar (browser support varies)
  // &navpanes=0 - Hide navigation panes
  const pdfUrl = `${url}#page=1&toolbar=0&navpanes=0`

  return (
    <div className="relative flex flex-col h-full rounded-lg border border-border bg-muted/30 overflow-hidden">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-background/80 z-10">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      )}
      <iframe
        src={pdfUrl}
        className="w-full h-full border-0"
        title="PDF Preview"
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
      />
    </div>
  )
}
